import { useCallback } from 'react'
import { useApolloClient } from '@apollo/client'

import { getCachedData, setCachedData } from '~/shared/utils'

/**
 *
 */
interface UseCacheReturn {
  getData: any
  setData: any
}

export default function useCache(): UseCacheReturn {
  const client = useApolloClient()

  const getData = useCallback(
    (options: any) => {
      return getCachedData(client, options)
    },
    [client],
  )

  const setData = useCallback(
    (options: any) => {
      return setCachedData(client, options)
    },
    [client],
  )

  return {
    getData,
    setData,
  }
}
